const isDocCollectSystemField = documentName =>
  documentName.match(/^w[ -]?(4|9)$/i);

export default isDocCollectSystemField;
